import { gsap } from "gsap"

const [ w, d ] = [ window, document ]

export default class INTRO{

  constructor(opt){
    this.opt = Object.assign( {
      titleText: '三方原台地でくらす',
      duration: [1,1,1],
      target: '.mainvisual',
      htmlClasses: {
        body_ready: 'is-intro-ready',
        body_start: 'is-intro-start',
        body_end: 'is-intro-end',
        container: 'intro',
        bg: 'intro__bg',
        title: 'intro__title'
      }
    }, opt)

    // DOMの読み込みが終わったらinit実行
    $(() => {
      Promise.all([ w.load['mainvisual'] ]).then( this.init )
    })

    // プロミスオブジェクト生成
    this.promise = new Promise( r => this.resolve = r )
  }

  init = () => {
    const opt = this.opt

    // splash用HTMLのルート要素作成
    this.container = d.createElement('section')
    this.container.setAttribute('class', 'intro')
    let contentsHtml = `
      <div class="${opt.htmlClasses.bg}"></div>
      <h2 class="${opt.htmlClasses.title}">${opt.titleText}</h2>
    `
    this.container.insertAdjacentHTML( 'beforeend', contentsHtml)

    // Bodyタグの最後にスプラッシュ要素を追加
    d.querySelector( opt.target ).appendChild( this.container )

    // 状態をBodyタグのクラスで表示
    d.body.classList.add( opt.htmlClasses.body_ready )
  }

  start = () => {
    const
      // オプションのエイリアス
      opt = this.opt,

      // コンテナ内の要素選択
      title = this.container.querySelector( '.' + opt.htmlClasses.title )

    // 状態をBodyタグのクラスで表示
    d.body.classList.remove( opt.htmlClasses.body_ready )
    d.body.classList.add( opt.htmlClasses.body_start )

    // greensockで各要素の初期状態設定
    gsap.set( title, { opacity: 0 } )
    
    // gsapのtimeline要素作成
    this.tl = gsap.timeline({
      defaults: {
        ease: "power2.out"
      }
    })
      .to( title, { opacity: 1, duration: opt.duration[1] }, opt.duration[0])
      // 完了時にdismissメソッド発火
      .eventCallback('onComplete', this.dismiss )
  }

  dismiss = () => {

    // オプションのエイリアス
    const opt = this.opt

    // 状態をBodyタグのクラスで表示
    d.body.classList.remove( opt.htmlClasses.body_ready )
    d.body.classList.remove( opt.htmlClasses.body_start )
    d.body.classList.add( opt.htmlClasses.body_end )

    // アニメーション中断
    // this.tl.kill()

    // コンテナをフェードアウトして要素自体を削除する
    gsap.to( this.container, {
      opacity: 0,
      duration: opt.duration[2],
      onComplete: () => {
        this.container.parentNode.removeChild( this.container )
        this.resolve( this.container )
      }
    })
  }


}